var React = require('react');

function Patient (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Bounding_Boxes","key":0},[React.createElement("g",{"id":"ui_x5F_spec_x5F_header_copy_2","key":0}),React.createElement("path",{"fill":"none","d":"M0,0h24v24H0V0z","key":1})]),React.createElement("g",{"id":"Rounded","key":1},React.createElement("path",{"d":"M15,11V5.83c0-0.53-0.21-1.04-0.59-1.41l-1.71-1.71c-0.39-0.39-1.02-0.39-1.41,0L9.59,4.41C9.21,4.79,9,5.3,9,5.83V7H5\n\t\tC3.9,7,3,7.9,3,9v10c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6c0-1.1-0.9-2-2-2H15z M7,19H5v-2h2V19z M7,15H5v-2h2V15z M7,11H5V9h2V11\n\t\tz M13,19h-2v-2h2V19z M13,15h-2v-2h2V15z M13,11h-2V9h2V11z M13,7h-2V5h2V7z M19,19h-2v-2h2V19z M19,15h-2v-2h2V15z"}))]);
}

Patient.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 24 24","enableBackground":"new 0 0 24 24","xmlSpace":"preserve"};

module.exports = Patient;

Patient.default = Patient;



//////////////////
// WEBPACK FOOTER
// /home/winc/bitbucket/iol2/sandbox-manager-v3/node_modules/svg-react-loader/lib/loader.js?name=Patient!./src/assets/icons/round-location_city.svg
// module id = 701
// module chunks = 1